// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"dfc08bff","142":"1e186a27","368":"35353201","414":"b60310a3","557":"f4c5c0b9","656":"2b1602ce","803":"c180d44f","902":"28d5a6c0","939":"db3096be","965":"9fef02e0"}[chunkId] + ".chunk.js";
};